module.exports = __webpack_public_path__ + "img/vignettes-asso_0012_psychodon.f823275f.jpg";